module.exports = __webpack_public_path__ + "img/ShadowMasquerade_EGM.b82abc87.jpg";